import { inject } from "aurelia";
import { ModelTypes } from '@zeus';
import { IDialogService } from '@aurelia/dialog';
import { ITemplateService } from '../../services/templates-service';
import { IZeusClient, ZeusClient } from "@services/graphql-service/zeus-client";
import { IRouter } from "@aurelia/router";
import { CreateBrandComponent } from "../../../brand-guide/components/create-brand/create-brand-component";
import { GenericListComparsionType, GenericListFildInputType, IGenericListConfig } from "@components/generic-list/interfaces/generic-filtered-interface";
import { toastifyError, toastifySuccess } from "@helpers/toastify";
import { GoPremiumDialog } from "@components/calendar/components/go-premium-dialog/go-premium-dialog";
import { IAuthService } from "@interfaces/auth-service/auth-service-interface";
@inject(IZeusClient, IRouter, ITemplateService, IDialogService, IAuthService)
export class PostTemplatesPage {
  private channel: string = 'posts';

  private brandId: string;
  private config: IGenericListConfig;
  private currentStep: number;

  constructor(
    private zeusClient: ZeusClient,
    private router: IRouter,
    private service: ITemplateService,
    private dialogService: IDialogService,
    private authService: IAuthService
  ) { }

  async loading() {
    const response = await this.zeusClient.chain('query')({
      brands: [
        { limit: 1 },
        {
          id: true,
          currentStep: true
        }
      ]
    })

    if (response?.brands?.length) {
      this.brandId = response?.brands[0]?.id as string;
      this.currentStep = response?.brands[0]?.currentStep;
    }

    this.config = {
      total: 0,
      tableName: 'project',
      streamName: 'project_stream',
      aggregateName: 'project_aggregate',
      columns: ['id', 'alias', 'status', 'type', 'previewImageFileId', 'publishDate', 'scheduledDate', 'deleted'],
      fixedFilters: [{
        comparsionType: GenericListComparsionType.Equals,
        title: 'brandId',
        field: 'brandId',
        type: GenericListFildInputType.Text,
        value: this.brandId,
      }, {
        comparsionType: GenericListComparsionType.In,
        title: 'type',
        field: 'type',
        type: GenericListFildInputType.Text,
        value: ['post'],
      }],
      filters: [],
      data: [],
      perPage: 12,
      currentPage: 1,
    }
  }

  private async getNewTemplateType(channel: string): Promise<ModelTypes['newTemplateType'][]> {
    const result = await this.service.getNewTemplateType(channel);

    return result;
  }

  private async deleteProject(projectId: string) {
    const { id } = await this.zeusClient.deleteProjectById(projectId);

    if (!id) {
      toastifyError({ message: 'Erro ao excluir criação' });
      return;
    }

    toastifySuccess({ message: 'Criação excluida com sucesso' });
  }

  private setIconByType(type: string): string {
    switch (type) {
      case 'image':
        return 'mdi mdi-image';
      case 'advert':
        return 'fa-solid fa-rectangle-ad';
      case 'post':
        return 'mdi mdi-calendar';
      case 'text':
        return 'mdi mdi-post-outline';
      case 'video':
        return 'mdi mdi-video';
      case 'print':
        return 'mdi mdi-printer';
      case 'presentation':
        return 'mdi mdi-presentation';
      default:
        return 'mdi mdi-help';
    }
  }

  private colorStatus(status: string): string {
    switch (status) {
      case 'draft':
        return 'red';
      case 'scheduled':
        return 'amber';
      case 'posted':
        return 'emerald';
      default:
        return 'blue';
    }
  }

  private async handleRedirect(): Promise<void> {
    if (!['user-premium', 'user-freetrial', 'copymagico-admin'].includes(this.authService.user?.defaultRole)) {
      await this.dialogService.open({
        component: () => GoPremiumDialog,
        model: {},
        lock: true,
        startingZIndex: 100,
      });

      return
    }

    if ((this.brandId && this.currentStep < 3) || !this.brandId) {
      await this.dialogService.open({
        component: () => CreateBrandComponent,
        model: {
        },
        lock: false,
        startingZIndex: 100,
      });

      return
    } else {
      await this.router.load('create-post');
    }
  }
}